import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Label, Input } from "reactstrap";

const batteryCapacities = [
  27.2, 60, 64, 900, 80, 40, 79.2, 41, 17.6, 74, 85, 75, 75, 35.8, 5.5, 100,
  5.4, 50, 50, 50, 72, 66, 40, 53, 70, 66, 71, 98, 70, 58, 160, 72, 51, 70, 100,
  105, 106,
];

const chargerPowers = [22, 60, 120, 180, 200, 240, 300];
const percentages = Array.from({ length: 10 }, (_, i) => (i + 1) * 10);
const currentCharge = Array.from({ length: 99 }, (_, i) => i + 1);

const ChargingCalculator = () => {
  const [battery, setBattery] = useState(27.2);
  const [charger, setCharger] = useState(22);
  const [target, setTarget] = useState(100);
  const [current, setCurrent] = useState(50);
  const { t } = useTranslation();


  const calculateTime = () => {
    if (target <= current) return "0 dakika";
    const energyNeeded = battery * (target - current) / 100;
    const hours = energyNeeded / charger;
    const totalMinutes = hours * 60;
    const minutes = Math.floor(totalMinutes);
    const seconds = Math.round((totalMinutes - minutes) * 60);
    return `${minutes} ${t("minute")} ${seconds} ${t("seconds")}`;
    };

  const formStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
  };

  const labelStyle = {
    minWidth: "160px",
    marginBottom: "0",
    marginRight: "50px",
  };

  const inputStyle = {
    flex: "1",
    maxWidth: "200px",
    width: "100%",
  };

  return (
    <div className="p-3  bg-white">
      <div style={formStyle}>
        <FormGroup className="d-flex justify-content-between">
          <Label style={labelStyle}> {t("battery_capacity")}</Label>
          <Input
            type="select"
            className="custom-input"
            style={{ inputStyle }}
            value={battery}
            onChange={(e) => setBattery(parseFloat(e.target.value))}
          >
            {batteryCapacities.map((val) => (
              <option key={val} value={val}>
                {val} kWh
              </option>
            ))}
          </Input>
        </FormGroup>
      </div>

      <div style={formStyle}>
        <FormGroup className="d-flex justify-content-between">
          <Label style={labelStyle}>{t("charge_power")}</Label>
          <Input
            type="select"
            className="custom-input"
            style={{ inputStyle }}
            value={charger}
            onChange={(e) => setCharger(parseFloat(e.target.value))}
          >
            {chargerPowers.map((val) => (
              <option key={val} value={val}>
                {val} kW
              </option>
            ))}
          </Input>
        </FormGroup>
      </div>
      <div style={formStyle}>
        <FormGroup className="d-flex justify-content-between">
          <Label style={labelStyle}>{t("goal_charge_time")}</Label>
          <Input
            type="select"
            className="custom-input"
            style={{ inputStyle }}
            value={target}
            onChange={(e) => setTarget(parseInt(e.target.value))}
          >
            {percentages.map((val) => (
              <option key={val} value={val}>
                {val}%
              </option>
            ))}
          </Input>
        </FormGroup>
      </div>
      <div style={formStyle}>
        <FormGroup className="d-flex justify-content-between">
          <Label style={labelStyle}>{t("avaliable_charge")}</Label>
          <Input
            type="select"
            className="custom-input"
            style={{ inputStyle }}
            value={current}
            onChange={(e) => setCurrent(parseInt(e.target.value))}
          >
            {currentCharge.map((val) => (
              <option key={val} value={val}>
                {val}%
              </option>
            ))}
          </Input>
        </FormGroup>
      </div>

      <div className="mt-3">
        <strong>{t("charge_time")}</strong> {calculateTime()} 
      </div>
    </div>
  );
};

export default ChargingCalculator;
